<template>
  <div id="hrms13x">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms13xIndex"
            searchBoxAlias="hrms13x"
            :detailEvent="detailEvent"
            :csvExportDisp="true"
            :listFields="listFields"
            :callSearchEvent="callSearchEvent" />
    <detail     v-show="detailDisp"
                :labels="labels[app.nowLang]"
                :labelsButton="app.button[app.nowLang]"
                :indexSelected="indexSelected"
                :detail="detail"
                :nowLang="app.nowLang"
                :toggle="toggle"
                :tab2Table="columns[app.nowLang].tab2" 
                :tab3Table1="columns[app.nowLang].tab3table1" 
                :tab3Table2="columns[app.nowLang].tab3table2" 
                :tab4Table="columns[app.nowLang].tab4" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms13x/mutation-types'
import detail from 'components/hrms13x/detail'

export default {
  name: 'hrms13x',
  data () {
    return {
      searchIndex: {},
      app: this.$parent.$parent.$parent
    }
  },
  created () {
    this.receivedHrms13xColumnsLabels()
    this.receivedHrms13xListFields()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS13X_INDEX_DISP,
      detailDisp: types.GET_HRMS13X_DETAIL_DISP,
      maxRowspan: types.GET_HRMS13X_MAX_ROWSPAN,
      columns: types.GET_HRMS13X_COLUMNS,
      labels: types.GET_HRMS13X_LABELS,
      index: types.GET_HRMS13X_INDEX,
      indexSelected: types.GET_HRMS13X_INDEX_SELECTED,
      detail: types.GET_HRMS13X_DETAIL,
      listFields: types.GET_HRMS13X_LISTFIELDS
    })
  },
  methods: {
    detailEvent (param) {
      this.setIndexSelected(param)
      this.receivedHrms13xDetail(this.indexSelected)
      this.toggle('detail')
    },
    callSearchEvent () {
      if (this.searchIndex.codempid !== '') {
        this.searchIndex.codcomp2 = ''
        this.searchIndex.syncond = {code: '', description: ''}
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS13X_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS13X_PAGE,
      receivedHrms13xColumnsLabels: types.RECEIVED_HRMS13X_COLUMNS_LABELS,
      receivedHrms13xIndex: types.RECEIVED_HRMS13X_INDEX,
      receivedHrms13xDetail: types.RECEIVED_HRMS13X_DETAIL,
      receivedHrms13xListFields: types.RECEIVED_HRMS13X_LISTFIELDS
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?ae098754